import {IUser} from 'MyModels';
import {combineReducers} from 'redux';
import {createReducer} from 'typesafe-actions';

import IInfo = MyTypes.IInfo;
import {clearData} from '../../election/store/actions';
import {
  loadUserAsync,
  loginAuthAsync,
  logoutAuthAsync,
  setUser,
  updatePwdAsync,
} from './actions';

const info = createReducer<IInfo>({loading: false, message: ''})
  .handleAction(
    [
      loadUserAsync.request,
      logoutAuthAsync.request,
      loginAuthAsync.request,
      updatePwdAsync.request,
    ],
    () => ({
      loading: true,
      message: '',
    })
  )
  .handleAction(
    [
      loadUserAsync.success,
      logoutAuthAsync.success,
      loginAuthAsync.success,
      updatePwdAsync.success,
    ],
    () => ({
      loading: false,
      message: '',
    })
  )
  .handleAction(
    [
      loadUserAsync.failure,
      logoutAuthAsync.failure,
      loginAuthAsync.failure,
      updatePwdAsync.failure,
    ],
    (state, action) => ({
      loading: false,
      message: action.payload,
    })
  );

const user = createReducer<IUser | null>(null) //
  .handleAction(setUser, (state, action) => ({...action.payload}))
  .handleAction([logoutAuthAsync.request, clearData], () => null);

const authReducer = combineReducers({
  info,
  user,
});

export default authReducer;
export type AuthState = ReturnType<typeof authReducer>;



// WEBPACK FOOTER //
// ./src/features/auth/store/reducer.ts